import type { TCounters } from '@/services/counters';

import { APPLICANT_LIST_VIEWS, MY_APPLICANTS_OPEN_STATUSES } from '@/constants/applicants';
import { toCounterKey } from '@/services/counters';

import type { TNavBadges } from 'constants/navigation';

const BOOK_UNSEEN = 'book_unseen';
const CHECK_OUTCOME = 'check_outcome';
const OWN_UNSEEN = 'own_unseen';
const PIPELINE_STATUS = 'pipeline_status';

const sumKeys = (counters: TCounters, bucket: string, keys: readonly string[]): number => keys
  .reduce((total, key) => total + (counters[toCounterKey(bucket, key)] ?? 0), 0);

const sumView = (
  counters: TCounters,
  bucket: string,
  viewID: keyof typeof APPLICANT_LIST_VIEWS,
): number => sumKeys(counters, bucket, APPLICANT_LIST_VIEWS[viewID].statuses ?? []);

const toNavBadges = (counters: TCounters | undefined, totalUnread: number): TNavBadges => {
  const badges: TNavBadges = { messages: totalUnread };

  if (!counters) {
    return badges;
  }

  return {
    ...badges,
    'new-applicants': sumView(counters, PIPELINE_STATUS, 'new-applicants'),
    'my-applicants': sumKeys(counters, OWN_UNSEEN, MY_APPLICANTS_OPEN_STATUSES),
    'verified': sumView(counters, PIPELINE_STATUS, 'verified'),
    'failed-background-check': sumKeys(counters, CHECK_OUTCOME, APPLICANT_LIST_VIEWS['failed-background-check'].checkOutcomes ?? []),
    'my-clients': sumKeys(counters, BOOK_UNSEEN, ['client']),
    'my-singles': sumKeys(counters, BOOK_UNSEEN, ['single']),
  };
};

export {
  sumKeys,
  toNavBadges,
};
